import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import { checkingDriverStatus, setAepsAmount, setAepsMobile, setAepsSection, setBiometricDtaCaptureStatus } from "../../redux/aeps/aeps.action";
import { Link } from "react-router-dom";
import { toHaveDisplayValue } from "@testing-library/jest-dom/dist/matchers";
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdbreact/dist/css/mdb.css';
import './aepscomp.css';
import moment from "moment";

const httpClient = axios.create();
class AEPSMinistatement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            amount: '',
            amountErrrMsg: '',
            aePsActionType: '',
            aePsActionErrMsg: '',
            deviceConnectStatus: 'LOADING',
            mobile: '',
            mobileErrorMsg: '',
            adhaarNo: '',
            adhaarErrMsg: '',
            searchableBankList: [],
            selectedBankName: '',
            selectedBankId: '',
            bankDetails: [],
            ifscCode: '',
            bankErrMsg: '',
        }
    }

    componentDidMount() {
        this.setState({
            mobileErrorMsg: '',
            amountErrrMsg: '',
            adhaarErrMsg: '',
            aePsActionErrMsg: '',
            bankErrMsg: ''
        })
        // this.loadBankDetails();
    }
    componentWillUnmount() {
    }
    showAepsForm = (e) => {
        e.preventDefault();
        store.dispatch(setAepsSection('aepsForm'));
    }

    render() {
        return (
            <div class="col-12 col-lg-7 col-xl-8">
                <div class="card-b" id="rightdiv">
                    <div id="aepsministmtdetail">
                        <div class="head">
                            <div class="hright">
                                <button class="close btn" data-toggle="tooltip" title="Close"
                                    onClick={this.showAepsForm}></button>
                            </div>
                            <h3>Mini Statement Details</h3>
                        </div>
                        <div class="reviewboxminis">
                           
                        </div>
                        <div class="reviewcard">
                                <div class="status">
                                    <h3 class="success">Mini Statement view successfully!</h3>
                                </div>
                                <hr />
                                <div class="leftreview">
                                    <img src="images/bank-logo.png" alt="bank" />
                                    <h5>{this.props.aepsFullName.toUpperCase()}</h5>
                                    <p>{this.props.selectedBankName}</p>
                                </div>

                                <div class="rightreview">
                                    <h5>Aadhaar No.: {this.props.aepsAadhaar.substring(0, 4) + 'XXXXXXXX'}</h5>
                                    <p>Mobile No.: {this.props.aepsMobile}</p>
                                </div>
                                <hr />
                                <div class="tnramount">
                                    <p>Amount:</p>
                                    <h5>₹ {parseFloat(this.props.aepsResponse.balance).toFixed(2)}</h5>
                                </div>


                                <hr />
                                <div class="txnreview">
                                    <h5>RRN. No.: {this.props.aepsResponse.bankId}</h5>
                                    <p>Date: {moment().format('DD-MM-YYYY HH:mm:ss')}</p>
                                </div>

                                <div class="minitxn">
                                    <h5>Mini Statement <span>Available Balance: ₹ {parseFloat(this.props.aepsResponse.balance).toFixed(2)}</span></h5>

                                    <div class="ministmnt">
                                        <div class="minihead">
                                            <div class="minidate">Date</div>
                                            <div class="miniremrk">Remark</div>
                                            <div class="minitype">Type</div>
                                            <div class="miniamt">Amount</div>
                                        </div>
                                        {this.props.aepsResponse.statement != null &&
                                            this.props.aepsResponse.statement.length > 0 &&
                                            this.props.aepsResponse.statement.map(statement => (
                                                <div class="minirow dr">
                                                    <div class="daterow">{(statement.date == null || statement.date == '') ?
                                                        'NA' : statement.date}</div>
                                                    <div class="remrkrow">{(statement.narration == null || statement.narration == '') ?
                                                        'NA' : statement.narration}</div>
                                                    <div class="typerow">{(statement.txnType == null || statement.txnType == '') ?
                                                        'NA' : statement.txnType}</div>
                                                    <div class="amtrow">₹ {parseFloat((statement.amount == null || statement.txnType == '') ? 0 :
                                                        statement.amount).toFixed(2)}</div>
                                                </div>
                                            ))
                                        }

                                    </div>
                                </div>

                                {/* <div class="txn-btn">
                                    <button type="button" class="print" data-toggle="tooltip" title="Print">Print</button>
                                    <button type="button" class="share" data-toggle="tooltip" title="Share">Share</button>
                                    <button type="button" class="help" data-toggle="tooltip" title="Help" onclick="window.location.href='help.html'">Support</button>
                                </div> */}
                            </div>
                    </div>

                </div>
            </div>

        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    aepsReduce: { aepsAmount,
        aepsResponse,
        aepsReq,
        aepsSelectedBank,
        aepsFullName,
        aepsMobile,
        aepsAadhaar },
    miscReduce: { phone, agentInfo, token ,selectedBankName}
}
) => ({
    errorMessage, loginErrorMessage, aepsAmount,
    aepsResponse,
    aepsReq,
    aepsSelectedBank,
    aepsFullName,
    aepsMobile,
    aepsAadhaar,
    phone, agentInfo, token,selectedBankName
});




export default connect(mapStateToProps, null)(AEPSMinistatement);
